'use strict';

const allNames = document.querySelectorAll('.section__name, .countdown_text');

for(const name of allNames) {
    const text = name.innerHTML;

    name.insertAdjacentHTML('afterend', `<div class='section__name-duplicate'>${text}</div>`);
}
